import React from "react";

import { about } from "../data";

import CarpenterLogo from "../assets/img/carpenter.jpg";

const AboutUs = () => {
  const { title, subtitle1, subtitle2, subtitle3, description1, description2 } =
    about;
  return (
    <section className="section" id="about">
      <div className="container mx-auto ">
        <div className="flex items-center justify-center">
          <img src={CarpenterLogo} alt="" width={500} className="rounded-sm" />
        </div>
        <div>
          <h2 className="title">{title}</h2>
          <p className="subtitle                                                                                                                                                                                                                                                                                                                           ">
            {subtitle1}
          </p>
          <p>{subtitle3}</p>
          <p className="mb-5">{subtitle2}</p>
          <p>{description1}</p>
          <p>{description2}</p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
